var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorneDIstanceE(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1201 183.48V172.28L66.04 195.82V209.39L22.1201 183.48Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4301 197.1L22.1201 172.3L189.56 73.1703L229.66 93.0001L66.4301 197.1Z",
    fill: "#72D09A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8999 209.71V196.45L229.66 92.8802V104.31L65.8999 209.71Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7401 163.06L32.3501 166.23L60.05 181.5L65.6801 177.97L37.7401 163.06Z",
    fill: "#F97E73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.92 146.37L60.53 149.55L88.2201 164.84L93.8501 161.31L65.92 146.37Z",
    fill: "#F97E73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.24 155.07L46.6499 157.8L64.7899 166.82L69.6699 163.71L51.24 155.07Z",
    fill: "#F97E73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2999 128.97L89.9199 132.17L117.69 147.32L123.3 143.76L95.2999 128.97Z",
    fill: "#F97E73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.8 112.63L117.44 115.86L145.29 130.85L150.89 127.26L122.8 112.63Z",
    fill: "#F97E73"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108 121.47L103.4 124.18L121.49 133.3L126.39 130.21L108 121.47Z",
    fill: "#F97E73"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M150.46 96.3202L145.06 99.4901L172.74 114.8L178.37 111.28L150.46 96.3202Z",
    fill: "#F97E73"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M178.56 79.6803L173.18 82.8702L200.93 98.0502L206.55 94.5001L178.56 79.6803Z",
    fill: "#F97E73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.55 88.5702L158.95 91.2902L177.08 100.35L181.96 97.2501L163.55 88.5702Z",
    fill: "#F97E73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.18 104.74L131.57 107.44L149.65 116.59L154.55 113.52L136.18 104.74Z",
    fill: "#F97E73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1201 138.53L74.55 141.29L92.7401 150.21L97.6001 147.07L79.1201 138.53Z",
    fill: "#F97E73"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.94 44.4003H151.52V37.7301H158.37V32.9003H151.52V26.3602H145.94V32.9003H139.15V37.7301H145.94V44.4003Z",
    fill: "#F97E73"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166.53 42.1603C173.74 36.6303 175.37 34.3302 175.37 30.8802C175.37 25.3702 170.98 23.4601 166.36 23.4601C163.65 23.4601 161.33 24.1302 159.29 25.1002L159.94 29.7601C161.14 29.0601 163.68 28.3102 165.74 28.3102C167.8 28.3102 169.53 28.8902 169.53 31.2902C169.53 32.9102 168.66 34.5002 166.84 36.1002L159.09 42.8802V46.9701H176.03V42.1603H166.53Z",
    fill: "#F97E73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.81 47.3102C191.45 47.3102 195.56 44.9601 195.56 39.2601C195.56 34.3501 191.3 31.9303 186.08 31.9303C185.4 31.9303 184.7 31.9802 184.36 32.0302L184.73 28.6302H194.56V23.8002H180.3L178.78 36.0902L179.84 36.9701C181.29 36.4801 182.97 36.2401 184.78 36.2401C187.97 36.2401 189.58 37.4001 189.58 39.4801C189.58 41.5601 188.11 42.5201 185.16 42.5201C183.06 42.5201 180.82 42.0403 178.68 40.9303L177.89 45.6903C180.06 46.7003 182.91 47.3102 185.81 47.3102Z",
    fill: "#F97E73"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M219.77 46.9701H225.15V36.3302C225.15 32.3302 222.16 30.2501 219.01 30.2501C216.94 30.2501 214.83 31.1101 213.49 32.9801C212.62 31.1701 210.53 30.2501 208.34 30.2501C206.41 30.2501 204.44 30.8502 203.28 32.3202L203.11 30.5902H198.17V46.9701H203.55V37.8602C203.55 36.0402 204.93 35.1703 206.28 35.1703C207.63 35.1703 208.96 36.0402 208.96 37.8602V46.9701H214.33V37.8602C214.33 36.0402 215.75 35.1703 217.09 35.1703C218.43 35.1703 219.77 36.0402 219.77 37.8602V46.9701Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorneDIstanceE);
export default __webpack_public_path__ + "static/media/borneDIstanceE.6c42a0a3c22652e00ab7db895162d2c4.svg";
export { ForwardRef as ReactComponent };